import React from 'react';
import { Box, Typography, Button, Avatar } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  
  const handleLogout = async () => {
    try {
      // Sign out from Firebase
      await logout();
      // Navigate to login page
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <div className="header">
      <Typography variant="h6" component="div">
        Website Content Management
      </Typography>
      
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
          <Avatar sx={{ width: 32, height: 32, mr: 1, bgcolor: '#1976d2' }}>
            {currentUser?.email?.charAt(0).toUpperCase() || 'A'}
          </Avatar>
          <Typography variant="body2">{currentUser?.email || 'Admin'}</Typography>
        </Box>
        
        <Button 
          variant="outlined" 
          color="error" 
          size="small" 
          startIcon={<LogoutIcon />}
          onClick={handleLogout}
        >
          Logout
        </Button>
      </Box>
    </div>
  );
};

export default Header;
